import { getBackendUrl } from "@Utils";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import ButtonComponent from "../form/ButtonComponent";
import { BUTTON_TYPES } from "../constants/globalVariable";
import axiosWrapper from "../../services/axiosWrapper";

/*
  Todo: cssclass is patch
*/
function EmbeddedLink({ widget, cssClass, disableLoad = false, showSmallerView = false }) {
  const { t } = useTranslation();
  const [linkData, setLinkData] = useState({});
  const [loadData, setLoadData] = useState(false);

  const handleLoadData = () => setLoadData(true);

  const getCrawledData = async () => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/userSettings/getCrawledData`, {
      link: widget.data.link,
    });
    if (response.data.status) {
      setLinkData({
        title: response.data.title,
        logo: response.data.logo,
        domain: response.data.domain,
        link: response.data.link,
      });
    }
  };

  useEffect(() => {
    getCrawledData();
  }, []);

  return (
    <>
      {loadData && <iframe title={t("Embedded Link")} className="w-full h-full" src={linkData.link} />}
      {!loadData && (
        <div
          className={`text-text_light p-6 flex flex-col items-center gap-3 h-full justify-between ${
            showSmallerView ? "text-xs" : "text-base"
          } ${cssClass}`}
        >
          <div className="flex gap-3 items-center">
            <img className={`${showSmallerView ? "w-6 h-6" : "w-10 h-10"}`} src={linkData.logo} />
            <div className="flex flex-col gap-1">
              <span>{linkData.title}</span>
              <span>{linkData.domain}</span>
            </div>
          </div>
          <div className="overflow-auto">{widget.data.description}</div>
          <ButtonComponent disabled={disableLoad} buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} onClick={handleLoadData}>
            Load
          </ButtonComponent>
        </div>
      )}
    </>
  );
}

export default EmbeddedLink;
